import { CountryCodes, Gazetteer } from '@bridebook/toolbox/src/gazetteer';
import { getAreaRegex } from '@bridebook/toolbox/src/search/area-regex';

/**
 * Area in the form the search API expects. The i18n format (area--adminArea1--countryCode) is
 * kept as is, other non-letters become spaces, and an area without letters becomes the country.
 */
export const getSearchRequestArea = (area: string, countryCode: CountryCodes) => {
  if (area.includes('--')) return area;

  const containsLetters = area.replace(getAreaRegex(false), '').length > 0;
  return containsLetters
    ? area.replace(getAreaRegex(false), ' ')
    : Gazetteer.getCountryName(countryCode);
};
